
import React from 'react';
import { Link } from 'react-router-dom';
import { AdSlot } from '../components/AdSlot';
import { ContextualCta } from '../components/ContextualCta';
import logo from '../images/og_logo.png';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <>
    <ContextualCta />
    <footer>
      <div className="py-12 md:py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">

          <AdSlot className="mb-8 md:mb-12" />

          {/* Top area: Blocks */}
          <div className="grid md:grid-cols-12 gap-8 lg:gap-20 mb-8 md:mb-12">

            {/* 1st block */}
            <div className="md:col-span-4 lg:col-span-5">
              <div className="mb-2">
                {/* Logo */}
                <Link to="/" className="inline-block" aria-label="sarah">
                  <div style={{ width: '100px', height: '60px' }}>
                    <img src={logo} alt="Logo" width="100" height="60" style={{ maxWidth: '100%', maxHeight: '100%' }} />
                  </div>
                </Link>
              </div>
              <div className="text-gray-400">Widerhofergasse 6 /12, 1090 Vienna, Austria.</div>
            </div>

            {/* 2nd, 3rd and 4th blocks */}
            <div className="md:col-span-8 lg:col-span-7 grid sm:grid-cols-3 gap-8">

              {/* Products column */}
              <div className="text-sm">
                <h6 className="text-gray-200 font-medium mb-2">Products</h6>
                <ul>
                  <li className="mb-1">
                    <Link to="/products/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Products</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/pricing/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Pricing</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/standards/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Standards</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/dora/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">DORA Compliance</Link>
                  </li>
                </ul>
              </div>

              {/* Resources column */}
              <div className="text-sm">
                <h6 className="text-gray-200 font-medium mb-2">Resources</h6>
                <ul>
                  <li className="mb-1">
                    <Link to="/blog/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Blog</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/insights/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Insights</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/glossary/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Glossary</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/publications/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Publications</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/ventures/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Ventures</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/partners/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Partners</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/expert-hub/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Expert Hub</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/portfolio/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Portfolio</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/careers/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Careers</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/quote/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Request a Quote</Link>
                  </li>
                </ul>
              </div>

              {/* Company / Legal column */}
              <div className="text-sm">
                <h6 className="text-gray-200 font-medium mb-2">Company</h6>
                <ul>
                  <li className="mb-1">
                    <Link to="/about/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">About Us</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/imprint/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Imprint</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/terms/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Terms</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/privacy/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Privacy Policy</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/cookie-policy/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Cookie Policy</Link>
                  </li>
                  <li className="mb-1">
                    <button
                      onClick={() => window.openCookieSettings?.()}
                      className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out text-left w-full"
                    >
                      Cookie Settings
                    </button>
                  </li>
                </ul>
              </div>

            </div>

          </div>

          {/* Tools area: one column per category */}
          <div className="mb-8 md:mb-12">
            <div className="flex items-baseline justify-between mb-4">
              <h6 className="text-gray-200 font-medium">Tools</h6>
              <Link to="/tools/" className="text-sm text-purple-400 hover:text-purple-300 transition duration-150 ease-in-out">All Tools →</Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-8 text-sm">

              {/* Image & PDF */}
              <div>
                <h6 className="text-gray-500 font-medium mb-2 text-xs uppercase tracking-wider">Image &amp; PDF</h6>
                <ul>
                  <li className="mb-1">
                    <Link to="/tools/html-to-image/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">HTML to Image</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/screenshot-to-image/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Screenshot to Image</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/pdf-tools/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">PDF Tools</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/merge-pdf/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Merge PDFs</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/split-pdf/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Split PDF</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/image-to-pdf/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Image → PDF</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/document-to-pdf/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Document → PDF</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/pdf-to-word/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">PDF → Word</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/pdf-metadata/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">PDF Metadata</Link>
                  </li>
                </ul>
              </div>

              {/* XML */}
              <div>
                <h6 className="text-gray-500 font-medium mb-2 text-xs uppercase tracking-wider">XML</h6>
                <ul>
                  <li className="mb-1">
                    <Link to="/tools/xml-tools/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">XML Tools</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/xml-formatter/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">XML Formatter</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/xml-validator/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">XML Validator</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/xml-to-json/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">XML → JSON</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/xml-minifier/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">XML Minifier</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/xpath-tester/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">XPath Tester</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/xml-to-csv/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">XML → CSV</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/xsd-validator/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">XSD Validator</Link>
                  </li>
                </ul>
              </div>

              {/* Developer */}
              <div>
                <h6 className="text-gray-500 font-medium mb-2 text-xs uppercase tracking-wider">Developer</h6>
                <ul>
                  <li className="mb-1">
                    <Link to="/tools/ethereum-toolkit/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Ethereum Toolkit</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/wei-converter/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Wei Converter</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/keccak256-hash/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Keccak256 Hash</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/function-selector/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Function Selector</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/abi-encoder/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">ABI Encoder</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/address-checksum/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Address Checksum</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/aws-arn-parser/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">AWS ARN Parser</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/iam-policy-validator/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">IAM Policy Validator</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/sap-odata-url-builder/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">SAP OData Builder</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/servicenow-query-builder/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">ServiceNow Query Builder</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/hash-generator/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Hash Generator</Link>
                  </li>
                </ul>
              </div>

              {/* Security & ISO */}
              <div>
                <h6 className="text-gray-500 font-medium mb-2 text-xs uppercase tracking-wider">Security &amp; ISO</h6>
                <ul>
                  <li className="mb-1">
                    <Link to="/tools/security-tools/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Security Scanner</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/blockchain-compliance-checker/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Blockchain Compliance</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/iso-27001-gap-analysis/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">ISO 27001 Gap Analysis</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/iso-9001-readiness-checker/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">ISO 9001 Readiness</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/iso-42001-ai-readiness/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">ISO 42001 AI Readiness</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/soc-2-readiness-checker/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">SOC 2 Readiness</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/iso-8601-validator/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">ISO 8601 Validator</Link>
                  </li>
                </ul>
              </div>

              {/* Finance */}
              <div>
                <h6 className="text-gray-500 font-medium mb-2 text-xs uppercase tracking-wider">Finance</h6>
                <ul>
                  <li className="mb-1">
                    <Link to="/tools/iban-validator/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">IBAN Validator</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/bic-validator/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">BIC Validator</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/lei-validator/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">LEI Validator</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/iso-20022-viewer/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">ISO 20022 Viewer</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/sepa-xml-validator/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">SEPA XML Validator</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/sepa-xml-generator/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">SEPA XML Generator</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/mt940-to-csv/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">MT940 to CSV</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/mt940-to-camt053/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">MT940 to camt.053</Link>
                  </li>
                </ul>
              </div>

              {/* Data & Other */}
              <div>
                <h6 className="text-gray-500 font-medium mb-2 text-xs uppercase tracking-wider">Data &amp; Other</h6>
                <ul>
                  <li className="mb-1">
                    <Link to="/tools/hl7-parser/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">HL7 Parser</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/fhir-validator/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">FHIR Validator</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/tle-parser/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">TLE Parser</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/tle-converter/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">TLE to JSON/CSV</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/scorm-validator/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">SCORM Validator</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/gtin-validator/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">GTIN Validator</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/phone-formatter/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Phone Formatter</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/vcard-generator/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">vCard Generator</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/email-validator/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Email Validator</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/csv-deduplicator/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">CSV Deduplicator</Link>
                  </li>
                  <li className="mb-1">
                    <Link to="/tools/word-counter/" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Word Counter</Link>
                  </li>
                </ul>
              </div>

            </div>
          </div>

          {/* Bottom area */}
          <div className="md:flex md:items-center md:justify-between">

            {/* Social links */}
            <ul className="flex mb-4 md:order-1 md:ml-4 md:mb-0">
              <li>
                <Link to="https://x.com/og_technologies" className="flex justify-center items-center text-purple-600 bg-gray-800 hover:text-gray-100 hover:bg-purple-600 rounded-full transition duration-150 ease-in-out" aria-label="X">
                  <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </Link>
              </li>
              <li className="ml-4">
                <Link to="https://github.com/ogtechnologiesco" className="flex justify-center items-center text-purple-600 bg-gray-800 hover:text-gray-100 hover:bg-purple-600 rounded-full transition duration-150 ease-in-out" aria-label="Github">
                  <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                  </svg>
                </Link>
              </li>
             
              <li className="ml-4">
                <Link to="https://www.linkedin.com/company/og-technologies-eu" className="flex justify-center items-center text-purple-600 bg-gray-800 hover:text-gray-100 hover:bg-purple-600 rounded-full transition duration-150 ease-in-out" aria-label="Linkedin">
                  <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </Link>
              </li>
              <li className="ml-4">
                <Link to="https://bsky.app/profile/did:plc:4njcm2f7fhkq4iyoeldn37ar" className="flex justify-center items-center text-purple-600 bg-gray-800 hover:text-gray-100 hover:bg-purple-600 rounded-full transition duration-150 ease-in-out" aria-label="Bluesky">
                  <svg className="w-8 h-8 fill-current" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.468 1.948C5.303 3.325 7.276 6.118 8 7.616c.725-1.498 2.698-4.29 4.532-5.668C13.855.955 16 .186 16 2.632c0 .489-.28 4.105-.444 4.692-.572 2.04-2.653 2.561-4.504 2.246 3.236.551 4.06 2.375 2.281 4.2-3.376 3.464-4.852-.87-5.23-1.98-.07-.204-.103-.3-.103-.218 0-.081-.033.014-.102.218-.379 1.11-1.855 5.444-5.231 1.98-1.778-1.825-.955-3.65 2.28-4.2-1.85.315-3.932-.205-4.503-2.246C.28 6.737 0 3.12 0 2.632 0 .186 2.145.955 3.468 1.948"/>
                  </svg>
                </Link>
              </li>
            </ul>

            {/* Copyright note */}
            <div className="text-gray-400 text-sm mr-4">
              &copy; {currentYear} OG Technologies EU. All rights reserved.
              <span className="mx-2 text-gray-600">·</span>
              <a
                href="https://techbehemoths.com/company/og-technologies-eu"
                target="_blank"
                rel="noopener"
                data-techbehemoths-verification
                className="hover:text-gray-100 transition duration-150 ease-in-out"
              >
                Verified on TechBehemoths
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
    </>
  );
}

export default Footer;
